import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18dece86"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"20px","font-weight":"500","color":"#000"} }, " 仕入れ商品情報 ", -1))
const _hoisted_2 = { class: "flex-ter" }
const _hoisted_3 = { style: {"width":"120px","text-align":"left"} }
const _hoisted_4 = {
  key: 0,
  class: "show-two-line"
}
const _hoisted_5 = { class: "show-two-line" }
const _hoisted_6 = { class: "show-one-line" }
const _hoisted_7 = { class: "product-sku-word" }
const _hoisted_8 = { class: "flex just-center" }
const _hoisted_9 = {
  class: "show-one-line",
  style: {"width":"200px"}
}
const _hoisted_10 = {
  key: 1,
  class: "show-one-line",
  style: {"width":"200px"}
}
const _hoisted_11 = { class: "flex-ter" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "show-two-line",
  style: {"width":"120px","text-align":"left"}
}
const _hoisted_14 = { class: "show-one-line" }
const _hoisted_15 = { class: "show-one-line" }

import { ref, onUnmounted, onMounted, nextTick, computed } from 'vue'
import STable from '@/components/Table/index.vue'
import { shopInfoDrawerColumns, groupTableConfig, combinationColumns } from './SalesPerspectiveData'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { QueryBindGoodsRespDTO } from '@/service/apis'
import AppLink from '@/components/common/AppLink.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import TableButton from '@/components/Table/TableButton.vue'
import { isJA, useRtfix } from '@/store'
import { setAdt } from '@/util/calcAdt'
import { batchQueryCombinationProduct } from '@/apis/order'
import { batchAddProduct, getCombinaProductDetailApi } from '@/apis/stock'
import { getCartAmount } from '@/apis/shopcart'
import { dayjs, ElMessageBox } from 'element-plus'
import SpecCol from '../../SpecificationColumn.vue'
import router from '@/router'
import { showCurrentUnit } from '@/util/useYan'
enum Enum_country {
  'CN' = t('中国'),
  'KR' = t('韩国'),
  'JP' = t('日本'),
}


export default /*#__PURE__*/_defineComponent({
  props: ['historyWhite'],
  setup(__props, { expose }) {

const props = __props
const visiable = ref(false)
const tableData = ref<QueryBindGoodsRespDTO[]>([])



const productTableConfig = {
  showSelection: false,
  setHeight: true,
  showExpand: true,
  rowKey: 'thirdSkuCode',
  expandConfigId: 'combinationProductItemList',
  showHandler: true,
  handlerConfig: {
    width: 180,
    // 操作栏的宽度
    handleWidth: 180,
    handlerHead: true,
    fixed: 'right'
  }
}
// 新增支持查历史换绑记录
const bindChangedFlag = ref('0')
// 三方sku编码
const thirdSkuCode = ref('')

// 国家枚举
onUnmounted(() => {
  window.removeEventListener('resize', changeTableWidth)
})

const finalShopInfoDrawerColumns = computed(() => {
  let nshopInfoDrawerColumns = shopInfoDrawerColumns
  if (!props.historyWhite) {
    nshopInfoDrawerColumns = shopInfoDrawerColumns.filter(i => i.prop !== 'historyPurchasedQuantity')
  }
  return nshopInfoDrawerColumns.filter(i => bindChangedFlag.value !== '0' || i.prop !== 'createTime')
})

const changeTableWidth = () => {
  // 计算展开table的宽度
  tableWidth.value = document.querySelector('.shop-info-drawer')?.clientWidth || 0
}

const tableWidth = ref(0)
const showBtn = ref(false)
onMounted(async () => {
  changeTableWidth()
  window.addEventListener('resize', changeTableWidth)
})

const queryBindGoods = async () => {
  try {
    const res = await await request.apis.thirdShopItem.queryBindGoods({
      thirdSkuCode: thirdSkuCode.value,
      bindChangedFlag: Number(bindChangedFlag.value)
    })
    console.log(res.data, 'res.data')
    tableData.value = (res.data ?? []).map(item => {
      if (item.productType == '3') {
        item.combinationProductItemList = [{}]
      }
      return item
    })
    visiable.value = true
  } catch (error) {

  }
}

expose({
  show: async (code: string) => {
    thirdSkuCode.value = code
    queryBindGoods()
  }
})

// 组合商品展开
const handleExpandRow = (val: any, flag: boolean) => {
  if (flag) {
    val.loading = true
    getCombinaProductDetailApi(val.productSku).then((res: any) => {
      val.combinationProductItemList = res.data?.combinationProductItemList || []
    }).finally(() => {
      val.loading = false
    })
  }
}
const addProduct = (params: any) => {
  return new Promise<void>((resolve, reject) => {
    batchAddProduct(params)
      .then(async (res: any) => {
        if (res.success) {
          resolve()
        } else {
          reject(new Error())
        }
      })
      .catch(() => {
        reject(new Error())
      })
  })
}
const showAddCartInfo = async (len: any, allSameCountry?: string) => {
  const amount = await getCartAmount().then((res) => res.data)
  ElMessageBox.confirm(
    `
        <div>${t('X件商品已添加至购物车').replace('X', len)}</div>
        <div>${t('当前购物车共X种商品').replace('X', amount)}</div>
      `,
    t('添加成功'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('去结算'),
      cancelButtonText: t('留在此页'),
      type: 'success'
    }
  ).then(() => {
    router.push(useRtfix('shopcart'))
  })
}

const productAddSingleCart = async (e: any) => {
  e.productAddLoading = true
  console.log(e.productType)
  // 商品类型: 1-普通商品; 2-OEM商品; 3-组合商品
  try {
    let list: any = []
    if (e.productType === 1) {
      const cartAdditionList: any = await setAdt(e.productCategoryFrontendNdId, 'cartAdditionList', 'noAdditionalFlag', [], undefined, false)
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: 1,
          allIncludeFlag: e.allIncludeAvailableQuantity > 0 ? 1 : 0,
          ...cartAdditionList
        }
      ]
    } else if (e.productType === 2) {
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: 1,
          oemOrderType: e.searchSourceOrderRepurchaseApplyId ? 4 : 2,
          searchSourceOrderCode: e.searchSourceOrderNo,
          searchSourceOrderId: e.searchSourceOrderId,
          searchSourceSupplierPriceId: e.searchSourcePriceId
        }
      ]
    } else if (e.productType === 3) {
      let combinationProductAdt = await batchQueryCombinationProduct({ combinationProductSkus: [e.productSku], withSubProduct: 1 })
      if (combinationProductAdt.code === '0') {
        combinationProductAdt = combinationProductAdt.data[0].combinationProductItems
      } else {
        return
      }
      const combinationProductItemAddCartList = await Promise.all(
        e.subProductList.map(async (e: any) => {
          const combinationProductAdtItemCache = combinationProductAdt.filter((y: any) => y.shopProductSku === e.shopProductSku)[0]
          const cartAdditionList: any = await setAdt(e.productCategoryFrontendNdId, 'combinationProductItemAdditionList', 'noAdditionalFlag', combinationProductAdtItemCache?.additionList, combinationProductAdtItemCache?.noAdditionalFlag, false)
          return {
            ...cartAdditionList,
            shopProductSku: e.shopProductSku
          }
        })
      )
      list = [
        {
          productType: e.productType,
          productSku: e.productSku,
          orderQuantity: 1,
          combinationProductItemAddCartList: combinationProductItemAddCartList
        }
      ]
    }
    await addProduct(list)
    // 当开通韩国商品授权之后才需要传。若是韩国商品跳转购物车选择韩国购物车
    showAddCartInfo(1)
    e.productAddLoading = false
  } catch (error) {
    e.productAddLoading = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ElDrawer = _resolveComponent("ElDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ElDrawer, {
    modelValue: visiable.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visiable).value = $event)),
    direction: "btt",
    size: "60%"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (__props.historyWhite)
          ? (_openBlock(), _createBlock(_component_el_tabs, {
              key: 0,
              modelValue: bindChangedFlag.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bindChangedFlag).value = $event)),
              onTabClick: queryBindGoods
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: _unref(t)('当前绑定'),
                  name: "0"
                }, null, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _unref(t)('历史绑定'),
                  name: "1"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          style: {"margin-top":"5px"},
          class: _normalizeClass({
        'histroyBind': bindChangedFlag.value == '1'
      })
        }, [
          _createVNode(STable, {
            ref: (_value, _refs) => {
              _refs['productRef'] = _value
            },
            tableData: tableData.value,
            tableConfig: productTableConfig,
            showPagination: false,
            onExpandRow: handleExpandRow,
            columns: _unref(finalShopInfoDrawerColumns),
            showAllExpand: false
          }, {
            productInfo: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createVNode(ShoppingPreview, {
                    image: row.productSkuImg || row.productMainImg || ''
                  }, null, 8, ["image"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (
                  (!row?.productType || row?.productType === 1) &&
                  row?.productCode
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_el_tooltip, { effect: "light" }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(AppLink, {
                              to: _unref(useRtfix)('goods', { params: { id: row?.productCode } }),
                              target: "_blank",
                              tag: "a"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row?.productTitle), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        effect: "light"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(row?.productTitle), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(row?.productTitle), 1)
                        ]),
                        _: 2
                      }, 1024))
                ])
              ])
            ]),
            productPropertiesName: _withCtx(({ row }) => [
              ((row.productPropertiesName || '').replace(/[+-]?\d+:[+-]?\d+:/ig, ''))
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "light",
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(row.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(row.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            productSku: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_tooltip, { effect: "light" }, {
                  content: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(row.productSku), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      (row.productCode && row.productType !== 2)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            target: "_blank",
                            tag: "a",
                            to: _unref(useRtfix)('goods', {
                    params: { id: row.productCode ?? 'null' },
                  })
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(row.productSku), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(row.productSku), 1)),
                      _createVNode(CopyButton, {
                        text: row.productSku
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]),
            createTime: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.createTime).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')), 1)
            ]),
            handler: _withCtx(({ scope }) => [
              _createVNode(TableButton, {
                disabled: bindChangedFlag.value == '1',
                title: _unref(t)('加入购物车'),
                loading: scope.row.productAddLoading,
                onClick: ($event: any) => (productAddSingleCart(scope.row))
              }, null, 8, ["disabled", "title", "loading", "onClick"])
            ]),
            expand: _withCtx(({ scope }) => [
              _withDirectives(_createElementVNode("div", {
                class: "table-combine",
                style: _normalizeStyle({ width: tableWidth.value + 'px' })
              }, [
                _createVNode(STable, {
                  "table-data": scope.row.combinationProductItemList,
                  columns: _unref(combinationColumns),
                  showPagination: false,
                  tableConfig: _unref(groupTableConfig)
                }, {
                  productInfo: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("img", {
                        src: row.productSkuImg,
                        alt: "",
                        style: {"width":"46px"}
                      }, null, 8, _hoisted_12),
                      _createVNode(_component_el_tooltip, {
                        effect: "light",
                        placement: "top"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(row.productTitle), 1)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(row.productTitle), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  purchaseCountry: _withCtx(({ row }) => [
                    _createElementVNode("div", null, _toDisplayString(Enum_country[row.purchaseCountry]), 1)
                  ]),
                  productSku: _withCtx(({ row }) => [
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(row.productSku), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(row.productSku), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  productPropertiesName: _withCtx(({ row }) => [
                    ((row.productPropertiesName || '').replace(/[+-]?\d+:[+-]?\d+:/ig, ''))
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "light",
                          placement: "top"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(row.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(row.productPropertiesName.replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  specificationTitle: _withCtx(() => [
                    _createVNode(SpecCol, { isTitle: true })
                  ]),
                  specification: _withCtx(({ row }) => [
                    _createVNode(SpecCol, { row: row }, null, 8, ["row"])
                  ]),
                  productSellPrice: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(row.productSellPrice) + _toDisplayString(_unref(isJA)() ? _unref(showCurrentUnit)(row.goodsCountry === 'KR') : ''), 1)
                  ]),
                  remainCombinationProductItemRespList: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString((row.remainCombinationProductItemRespList || []).reduce((total, v): number => {
                    return total + v.remainCombinationQuantity
                  }, 0)), 1)
                  ]),
                  _: 2
                }, 1032, ["table-data", "columns", "tableConfig"])
              ], 4), [
                [_directive_loading, scope.row.loading]
              ])
            ]),
            _: 1
          }, 8, ["tableData", "columns"])
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})